import React, {useState, useEffect, useRef} from "react";
import "./style.css";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isNullOrUndefinedOrEmpty, userIsNotLoggedIn } from "../../../utils.js";
import { TableHead, TableCell, TableRow, TableContainer, Table, TableBody, Container } from "@mui/material";
import { fetchMetrcAccounts } from "../../../redux/models/integrations/Action.js";
import { selectOrganization } from "../../../redux/models/organizations/Action.js";
import {isEmpty} from "weed-js";
import Loading from "../../../components/elements/Loading.js";


const List = ({subscriptions, subscriptionItems, subscriptionProducts}) => {
    const [metrcAccounts, setMetrcAccounts] = useState([]);

    const abortControllerRef = useRef(null);
    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user || {});
    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations);
    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization || {});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isEmpty(organizations)) return;

        abortControllerRef.current?.abort(); // cancel previous request
        abortControllerRef.current = new AbortController();

        const params = isEmpty(selectedOrganization) ? {} : { organization_id: selectedOrganization.id };
        dispatch(fetchMetrcAccounts(params, abortControllerRef.current)).then((fetchedMetrcAccounts) => {
            setMetrcAccounts(fetchedMetrcAccounts);
            setIsLoading(false);
        }).catch(err => {
            if (err.name !== "AbortError") {
                console.error("Failed to fetch Metrc accounts:", err);
                setIsLoading(false);
            }
        });

        return () => {
            abortControllerRef.current?.abort(); // abort on unmount or dependency change
        };
    }, [loggedInUser.id, selectedOrganization.id]);

    if (userIsNotLoggedIn(loggedInUser)) {
        navigate("/login");
        return "User is not logged in.";
    }

    const maybeSwitchOrganization = (organization) => {
        if (selectedOrganization.id !== organization.id) {
            dispatch(selectOrganization(organization));
        }
    };

    const noIntegrations = <Link to="/integrations/metrc/setup">
        You have no metrc integrations. Go to Integrations, then Setup to add some or click here.
    </Link>;

    if (isLoading) {
        return <Container className={"workspace"}>
            <h1>Loading Metrc Integrations...</h1>
            <Loading />
        </Container>;
    }

    if (isEmpty(metrcAccounts)) {
        return <Container className={"workspace"}>
            <h1>Manage Metrc Integrations</h1>
            <p>{noIntegrations}</p>
        </Container>;
    }

    return <Container className={"workspace"}>
        <h1>Manage Metrc Integrations</h1>
        <p>Learn about managing usage and quotas <a href={"https://www.youtube.com/watch?v=4oDkrzCtm4Q"}>here</a></p>
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Organization Name</TableCell>
                        <TableCell>Metrc Account Name</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        metrcAccounts.sort((a, b) => {
                            return a.display_name.localeCompare(b.display_name);
                        }).map((metrcAccount) => {
                            const organization = organizations.find(o => metrcAccount.organization_id === o.id);
                            if (isEmpty(organization) || metrcAccount.organization_id !== selectedOrganization.id) {
                                return null;
                            }
                            return <TableRow key={metrcAccount.id}>
                                <TableCell>
                                    <Link to={`/integrations/metrc/${metrcAccount.id}/detail`} onClick={() => {
                                        maybeSwitchOrganization(organization);
                                    }}>
                                        {organization.name}
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    <Link to={`/integrations/metrc/${metrcAccount.id}/detail`} onClick={() => {
                                        maybeSwitchOrganization(organization);
                                    }}>
                                        {metrcAccount.display_name}
                                    </Link>
                                </TableCell>
                            </TableRow>;
                        })
                    }
                </TableBody>
            </Table>
        </TableContainer>
    </Container>;
};

export default List;